<template>
  <div>
    <loading-spinner v-if="loading"></loading-spinner>
    <template v-else>
      <header-card
        icon="analytics"
        title="Business Metrics"
        sub-title="Manage the business metrics that can be reported on"
      >
      </header-card>
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-for="(businessMetric, i) in business_metrics"
          :key="i"
        >
          <business-metric-card
            :businessMetric="businessMetric"
            v-on:edit="editBusinessMetric(businessMetric)"
            v-on:delete="deleteBusinessMetric(businessMetric.id)"
            v-on:manage="manageItems(businessMetric)"
          ></business-metric-card>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <add-business-metric-card
            v-on:add="editBusinessMetric(null)"
          ></add-business-metric-card>
        </v-col>
      </v-row>
    </template>
    <business-metric-items-dialog
      ref="itemsDialog"
    ></business-metric-items-dialog>
    <edit-business-metric-dialog
      ref="editBusinessMetric"
    ></edit-business-metric-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BusinessMetricCard from "@/components/metrics/BusinessMetricCard";
import AddBusinessMetricCard from "@/components/metrics/AddBusinessMetricCard";
import HeaderCard from "@/components/common/HeaderCard";
import EditBusinessMetricDialog from "@/components/metrics/EditBusinessMetricDialog";
import BusinessMetricItemsDialog from "@/components/metrics/BusinessMetricItemsDialog";
export default {
  name: "BusinessMetricsList",
  components: {
    BusinessMetricCard,
    AddBusinessMetricCard,
    HeaderCard,
    EditBusinessMetricDialog,
    BusinessMetricItemsDialog
  },
  props: {},
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters({
      business_metrics: "company/business_metrics",
      is_admin: "profile/is_admin"
    })
  },
  created() {
    this.getBusinessMetrics();
  },
  methods: {
    getBusinessMetrics() {
      this.loading = true;
      this.$store
        .dispatch("company/getBusinessMetrics")
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            `An error occured while loading business metrics.`
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editBusinessMetric(businessMetric) {
      this.$refs.editBusinessMetric.showDialog(businessMetric || {});
    },
    manageItems(businessMetric) {
      this.$refs.itemsDialog.showDialog(businessMetric);
    },
    async deleteBusinessMetric(id) {
      if (
        await this.$root.$confirm(
          "Delete business metric",
          "Are you sure you want to delete this business metric?",
          { color: "red" }
        )
      ) {
        this.saving = true;
        this.$store
          .dispatch("company/deleteBusinessMetric", id)
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess("Business metric deleted");
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while deleting a business metric."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
